import React from "react";

const Pen = ({
  className,
  role,
  ignoreDefaultSize,
  width = 24,
  height = 24,
  strokeWidth,
  onClick,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={ignoreDefaultSize ? undefined : width}
      height={ignoreDefaultSize ? undefined : height}
      viewBox="0 0 24 24"
      role={role}
      className={className}
      strokeWidth={strokeWidth}
      onClick={onClick}
    >
      <path
        d="M21 11v1a9 9 0 0 1-9 9 9 9 0 0 1-9-9 9 9 0 0 1 9-9h1"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        stroke="currentColor"
      />
      <path
        d="M20.707 4.707l-1.414-1.414a1 1 0 0 0-1.414 0L8.712 12.46v2.828h2.828l9.167-9.167a1 1 0 0 0 0-1.414z"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        stroke="currentColor"
      />
      <path
        d="M18.91 7.91l-2.82-2.82"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        stroke="currentColor"
      />
    </svg>
  );
};

export default React.memo(Pen);
